<template>
<section
  class="sign-wrapper-cover"
>
  <section
    :style="{width:wrapperWidth,height:wrapperHeight}"
    class="sign-wrapper"
  >
    <section class="sign-header">
      <van-nav-bar
        :title="title"
        left-text="返回"
        right-text="清除"
        left-arrow
        @click-left="onBackBtnLeft"
        @click-right="onClearBtnRight"
      />
    </section>

    <section class="sign-body">
      <section ref="signCanvasWrapper" class="sign-canvas-wrapper">
        <canvas
          ref="signCanvas"
          :width="canvasWidth"
          :height="canvasHeight"
          @touchstart="onTouchStart"
          @touchmove="onTouchMove"
        />
      </section>
    </section>

    <section class="sign-footer" :style="{
     '--grid-columns': 1 + isNet
    }">
      <van-button round block type="primary" @click="onOkBtnClick" >确定</van-button>
      <van-button round block type="warning" style="position:relative;overflow:hidden;">
        <label class="file-label">
          <span>从文件选择</span>
          <input type="file" accept="image/*" @change="onSignImgChanged" />
        </label>
      </van-button>
    </section>
  </section>
</section>
</template>

<script>
export default {
  name: 'SignCanvas',
  props: {
    title: String
  },
  data () {
    let width
    let height
    if (/^https?:$/.test(location.protocol)) {
      width = '835px'
      height = '500px'
    } else {
      width = `${screen.width}px`
      height = `${screen.height}px`
    }
    return {
      wrapperWidth: width,
      wrapperHeight: height,
      canvasWidth: 100,
      canvasHeight: 100
    }
  },
  computed: {
    isNet () {
      return /^https?:$/.test(location.protocol)
    }
  },
  methods: {
    getSignCanvas () {
      return this.$refs.signCanvas
    },
    setCanvasSize () {
      let {signCanvasWrapper} = this.$refs
      this.canvasWidth = signCanvasWrapper.offsetWidth
      this.canvasHeight = signCanvasWrapper.offsetHeight
    },
    setCtx () {
      let signCanvas = this.getSignCanvas()
      this.ctx = signCanvas.getContext('2d')
    },
    getCanvasClientRect () {
      return this.getSignCanvas().getClientRects()[0]
    },
    getTouchObj (event) {
      let touches = event.touches

      if (touches.length > 1) {
        return null
      }

      return touches[0]
    },
    onTouchStart (event) {
      let touchObj = this.getTouchObj(event)

      if (!touchObj) {
        return
      }

      let rect = this.getCanvasClientRect()
      let ctx = this.ctx
      ctx.beginPath()
      ctx.lineWidth = 4
      ctx.strokeStyle = '#000000'
      ctx.moveTo(touchObj.clientX - rect.x, touchObj.clientY - rect.y)
    },
    onTouchMove (event) {
      let touchObj = this.getTouchObj(event)

      if (!touchObj) {
        return
      }

      let rect = this.getCanvasClientRect()
      let ctx = this.ctx
      ctx.lineTo(touchObj.clientX - rect.x, touchObj.clientY - rect.y)
      ctx.stroke()
    },
    onBackBtnLeft () {
      this.$emit('back')
    },
    onClearBtnRight () {
      let rect = this.getCanvasClientRect()
      this.ctx.clearRect(0, 0, rect.width, rect.height)
    },
    onOkBtnClick () {
      let tmpCanvas = document.createElement('canvas')
      let width = 240
      let height = this.canvasHeight / (this.canvasWidth / width)
      let tmpCtx = tmpCanvas.getContext('2d')
      let rect = this.getCanvasClientRect()

      tmpCanvas.width = width
      tmpCanvas.height = height

      tmpCtx.drawImage(
        this.getSignCanvas(),
        0, 0,
        rect.width, rect.height,
        0, 0,
        width, height
      )

      this.$emit('ok', tmpCanvas.toDataURL('image/jpg'))
    },
    onSignImgChanged (event) {
      let [file] = event.target.files

      if (!file) {
        return
      }

      let reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = event => {
        let image = new Image()
        image.src = event.target.result
        image.onload = () => {
          let canvas = this.$refs.signCanvas
          let ctx = canvas.getContext('2d')
          let imageWidth = image.width
          let imageHeight = image.height
          let canvasWidth = canvas.width
          let canvasHeight = canvas.height
          let imageRatio = imageWidth / imageHeight
          let canvasRatio = canvasWidth / canvasHeight
          let width = canvasWidth
          let height = canvasHeight

          if (imageRatio >= canvasRatio) {
            height = canvasWidth / imageRatio
          } else {
            width = canvasHeight * imageRatio
          }

          ctx.clearRect(0, 0, canvasWidth, canvasHeight)
          ctx.drawImage(image, (canvasWidth - width) / 2, (canvasHeight - height) / 2, width, height)
        }
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.setCanvasSize()
      this.setCtx()
    })
  }
}
</script>

<style lang="scss" scoped>
.sign-wrapper-cover {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, .5);
  z-index: 10;

  .sign-wrapper {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    padding: 46px 0 65px;
    background-color: #f7f8fa;
    box-shadow: 0 0 20px 4px rgba(0, 0, 0, .075);

    .sign-header {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
    }

    .sign-body {
      width: 100%;
      height: 100%;
      padding: 20px;

      .sign-canvas-wrapper {
        position: relative;
        width: 100%;
        height: 100%;
        background-color: #FFFFFF;
        box-shadow: 0 0 20px 4px rgba(0, 0, 0, .075);
      }
    }

    .sign-footer {
      position: absolute;
      display: grid;
      grid-template-columns: repeat(var(--grid-columns), 1fr);
      grid-column-gap: 12px;
      bottom: 0;
      left: 0;
      width: 100%;
      padding: 10px 20px;
      border-top: 1px solid #ebedf0;
      background-color: #FFFFFF;
    }
  }
}

.file-label {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

input[type="file"] {
  position: absolute;
  top: -9999px;
  left: -9999px;
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/08Sign/SignCanvas.vue